import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { AgGridReact } from "ag-grid-react";
import { AllEnterpriseModule } from 'ag-grid-enterprise';
import { ModuleRegistry, AllCommunityModule, themeBalham } from 'ag-grid-community';
import { useMemo, useEffect, useState, useRef } from 'react';
import ListEditRenderer from "./RenderListEdit.js";
import { removererendergrid } from '../modules/formstore';
import {
    isEmpty, isEnabled, CellType, RandomKey, Floor, FormatDate, isDate, toHalfWidth, trim, DicVal, Round, continueSession, getFirstDigits,
    isNumber, PadZero, tagformat, numformat, removetag, toStringDate, replaceall, NumConv, DeepCopy, GetDesitRound, getInteferPointLength
} from '../modules/appLibrary';
import AGFunction from "./AGFunction";

// 必要なモジュールを登録
ModuleRegistry.registerModules([
    AllEnterpriseModule,
    AllCommunityModule
]);

//--------------------------------------------------------
//  明細Grid
//
//  id : 明細識別子
//  elemid:
//  columns
//  fnc
//  entrydataRef:基本情報
//  dataRef:明細データ
//  columnRef:現在列状態
//  columninfo：カラム情報
//  statusKey:列状態保存キー
//  AutoAddRow:false=自動行追加しない 既定値:true
//  total=true:合計行
//  nogriptitle:total=true時「計」表示なし
//  rowDrag=false:行並び替え不可
//  rowContext=false:コンテキストメニュなし 1:コピー以外なし
//  masterDetail=true:masterDetail有
//  panel=panel情報
//  fillHandleDirection=x/y/xy 規定値:y
//  maximize=True:最大化（スクロールなし）
//-------------------------------------------------------
// Event
//  onGridReady
//  onFirstDataRendered
//  ValueChanged:値変更
//  ColumnVisible:列表示変更
//  RowValueChanged:行データ変更
//  SetTriggerfield:SKU追加等による関連項目連携
//  RemoveRow:行削除
//  SwapRow:行入れ替え
//  QueryRemoveRow:行削除前
//  QueryInsertRow:行挿入前
//  ColdefSpecial:列定義
//  QuerySetColumn:列設定前
//  SearchClick:マスタ検索コマンドクリック
//--------------------------------------------------------
export default function EntryGrid(props) {

    const colDefsInit = { field: 'rowid', colId: 'rowid', initialHide: true, hide: true, suppressColumnsToolPanel: true, filter: false };

    const user = useSelector(state => state.user);
    const menudata = useSelector(state => state.menu);
    const entrylock = useSelector(state => state.form.entryformlock);
    const initlayout = useSelector(state => state.toolpnl.initlayout_et);
    const triggercall = useSelector(state => state.form.entrytriggercall);
    const entrytriggerfield = useSelector(state => state.form.entrytriggerfield);
    const themestyle = useSelector(state => state.form.themestyle);
    const ctrls = useSelector(state => state.form.ctrls);
    const rerendergrid = useSelector(state => state.form.rerendergrid);
    const gridmaximize = useSelector(state => state.form.gridmaximize);
    const formstatus = useSelector(state => state.form.status);
    const admin = useSelector(state => state.user.authority);
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [rowData, setRowData] = useState([]);
    const [columns, setcolumns] = useState([colDefsInit]);
    const [listlock, setlistlock] = useState(false);
    const [maxheight, setmaxheight] = useState(false);
    const [maximize, setmaximize] = useState(false);
    const [displayedRowCount, setDisplayedRowCount] = useState(0);
    const [detailCellRendererParams, setdetailCellRendererParams]= useState(null);
    const RowNodeId = data => data.rowid;
    const dispatch = useDispatch();
    const fnc = props.fnc;
    const CELLTYPE = CellType();
    const AGFunc = React.forwardRef(AGFunction);
    const gridMax = useRef({height: '320px', count:10});
    const AGRef = useRef();
    const Suppress = useRef(false);
    const search = useLocation().search;
    const gridHeaderHeight = 30;
    const gridRowHeight = 28;
    const gridFrameHeight = 2;
    const gridcontext = {
        entrylock: entrylock,       //ロック情報 1:ロック
    };

    useEffect(() => {
        let g_column = props.columnRef.current;
        if (isValidcolumndef(g_column)) {
            DidMountSetColumn(g_column);
            //    setcolumns(g_column);
        } else {
            if (isEmpty(props.columninfo) || isEmpty(props.columns)) return;
            let column = createColDef(props.columninfo.filter(e => e.type === props.type), props.columns);
            DidMountSetColumn(column);
            //setcolumns(column);
        }
        let g_row = props.dataRef.current;
        if (!isEmpty(g_row)) {
            applyRowData(g_row);
        } else {
            if (props.AutoAddRow === false) {
                applyRowData([]);
            } else {
                if (props.total) {
                    applyRowData([{ rowid: "TOTAL", grip: props.nogriptitle?"":"計" }]);
                } else {
                    applyRowData([{ rowid: newrowid(props.id) }]);
                }
            }
        }
        CalcGridmax();
    }, [search]);

    useEffect(() => {
        //FORMレイアウトロック制御
        setlistlock(ctrls.indexOf("LOCK2") !== -1)
    }, [ctrls]);

    useEffect(() => {
        if (props.id in gridmaximize) {
            if (maximize === gridmaximize[props.id]) {
                return;
            }
        } else { return; }
        let max = !maximize;
        setmaximize(max);
        if (isEmpty(gridApi)) return;
        if (max) {
            gridApi.setGridOption('domLayout', 'autoHeight'); //スクロールなし
        } else {
            gridApi.setGridOption('domLayout', maxheight ? 'normal' : 'autoHeight');
        }
    }, [gridmaximize]);


    useEffect(() => {
        //ウィンドウサイズ変更
        if (isEmpty(DicVal(props.panel, 'gridmax', ''))) return;
        if (props.panel.gridmax === '100%') {
            CalcGridmax();
        }
    }, [props.EntrybodyRef]);

    function CalcGridmax() {
        if (isEmpty(DicVal(props.panel, 'gridmax', ''))) return;
        var h = 0;
        if (props.panel.gridmax === '100%') {
            h = props.EntrybodyRef.current.clientHeight - 150;
        } else {
            h = NumConv(props.panel.gridmax);
        }
        if (h === 0) return;
        gridMax.current.height = h + 'px';
        gridMax.current.count = Round((h - 40) / 28, 0);  //28=RowHeight
    }

    useEffect(() => {
        if (isEmpty(gridApi)) return;
        if (maximize) {
            gridApi.setGridOption('domLayout', 'autoHeight');   //スクロールなし
        } else {
            gridApi.setGridOption('domLayout', maxheight ? 'normal' : 'autoHeight');
        }
    }, [maxheight]);

    useEffect(() => {
        if (rerendergrid.indexOf(props.id) !== -1) {
            DidMountSetColumn(props.columnRef.current);
            let g_row = props.dataRef.current;
            applyRowData(g_row);
            dispatch(removererendergrid({ rerendergrid: props.id }));
        }
    }, [rerendergrid]);

    useEffect(() => {
        setdetailCellRendererParams(props.detailCellRendererParams);
    }, [props.detailCellRendererParams]);


    function resolveColumnDefs(colDef) {
        let nextColDef = colDef;
        if (!isValidcolumndef(nextColDef)) {
            if (isEmpty(props.columninfo) || isEmpty(props.columns)) {
                return [colDefsInit];
            }
            nextColDef = createColDef(props.columninfo.filter(e => e.type === props.type), props.columns);
        }
        if (!isEmpty(props.QuerySetColumn)) {
            let queriedColDef = props.QuerySetColumn(nextColDef);
            if (isValidcolumndef(queriedColDef)) {
                nextColDef = queriedColDef;
            }
        }
        if (!isValidcolumndef(nextColDef)) {
            return [colDefsInit];
        }
        return nextColDef;
    }

    function DidMountSetColumn(colDef) {
        setcolumns(resolveColumnDefs(colDef));
    }

    useEffect(() => {
        if (isEmpty(gridApi)) return;
        if (isEmpty(entrytriggerfield)) return;
        if (isEmpty(props.columninfo)) return;
        let coldefs = props.columninfo.filter(e => e.columnid === entrytriggerfield);
        let colinfos = props.columninfo.filter(e => e.type === props.type);
        //対象項目かチェック
        let extrigger = coldefs[0].extrigger;
        let isTarget = false;
        let chgformat = false;
        for (let i = 0; i < extrigger.length; i++) {
            if (colinfos.some(e => e.columnid === extrigger[i].columnid)) {
                isTarget = true     //マスタ値参照
            }
        }
        fnc.current.clearentrytrigger();
        if (!isTarget) return;
        let rows = [];
        gridApi.forEachNode(function (node) {
            let data = node.data;
            if (!isEmpty(props.entrydataRef)) {
                data = { ...data, ...props.entrydataRef.current };
            }
            rows.push(data);
        });
        //外部コール　マスタ項目取得
        if(rows.length !== 0)
            fnc.current.getRowMasterdata(coldefs, props.columninfo, rows, (data) => rowcallback(data, rows), true);

    }, [triggercall]);

    useEffect(() => {
        if (isValidcolumndef(columns))
            props.columnRef.current = columns;
    }, [columns]);

    //列情報が有効かチェック
    function isValidcolumndef(coldef) {
        if (isEmpty(coldef)) return false;
        let col = coldef.filter(e => e.colId !== 'rowid' && e.colId !== 'grip');
        if (isEmpty(col)) return false;
        return col.length !== 0;
    }

    function paneltype() {
        if (isEnabled(props.total)) return props.panel.totaltype;
        else return props.panel.type;
    }

    function newrowid(id) {
        return id + "_" + RandomKey();
    }

    function getMaxRowCount() {
        let maxrow = NumConv(DicVal(props.panel, 'maxrow', 0));
        return maxrow > 0 ? maxrow : 0;
    }

    function getInitRowCount() {
        if (props.total) return 0;
        let initrow = NumConv(DicVal(props.panel, 'initrow', 0));
        if (initrow <= 0) return 0;
        let maxrow = getMaxRowCount();
        if (maxrow > 0) {
            return Math.min(initrow, maxrow);
        }
        return initrow;
    }

    function createEmptyRows(rowcount) {
        let rows = [];
        for (let i = 0; i < rowcount; i++) {
            rows.push({ rowid: newrowid(props.id) });
        }
        return rows;
    }

    function fillInitRows(rows) {
        let newrows = isEmpty(rows) ? [] : [...rows];
        let initrow = getInitRowCount();
        if (initrow <= 0 || newrows.length >= initrow) return newrows;
        return newrows.concat(createEmptyRows(initrow - newrows.length));
    }

    function applyRowData(rows) {
        let newrows = fillInitRows(rows);
        props.dataRef.current = newrows;
        setDisplayedRowCount(newrows.length);
        setRowData(newrows);
    }

    function syncGridHeightState(api) {
        let rowcount = displayedRowCount;
        if (!isEmpty(api)) {
            rowcount = api.getDisplayedRowCount();
        }
        setDisplayedRowCount(rowcount);
        setmaxheight(rowcount >= gridMax.current.count);
        return rowcount;
    }

    function getGridStyle() {
        const visibleRowCount = Math.max(displayedRowCount, 1);
        if (maxheight && !maximize) {
            return { width: '100%', height: gridMax.current.height };
        }
        if (props.fitMinHeightToRows) {
            return {
                width: '100%',
                minHeight: gridHeaderHeight + (visibleRowCount * gridRowHeight) + gridFrameHeight,
            };
        }
        return {
            width: '100%',
            minHeight: gridHeaderHeight + (visibleRowCount * gridRowHeight) + gridFrameHeight,
        };
    }

    function getAddableRowCount(rowcount, api) {
        let maxrow = getMaxRowCount();
        if (maxrow <= 0) return rowcount;
        let grid = isEmpty(api) ? gridApi : api;
        if (isEmpty(grid)) return rowcount;
        return Math.max(0, Math.min(rowcount, maxrow - grid.getDisplayedRowCount()));
    }

    function getInsertOverflowRowCount(rowcount, api) {
        let maxrow = getMaxRowCount();
        if (maxrow <= 0) return 0;
        let grid = isEmpty(api) ? gridApi : api;
        if (isEmpty(grid)) return 0;
        return Math.max(0, grid.getDisplayedRowCount() + rowcount - maxrow);
    }

    function removeLastDisplayedRows(rowcount, api) {
        let grid = isEmpty(api) ? gridApi : api;
        if (isEmpty(grid) || rowcount <= 0) return 0;
        let displayed = grid.getDisplayedRowCount();
        let removelist = [];
        for (let i = Math.max(0, displayed - rowcount); i < displayed; i++) {
            let node = grid.getDisplayedRowAtIndex(i);
            if (!isEmpty(node)) {
                removelist.push(node.data);
            }
        }
        if (removelist.length === 0) return 0;
        grid.applyTransaction({ remove: removelist });
        return removelist.length;
    }

    function showMaxRowWarning() {
        let maxrow = getMaxRowCount();
        if (maxrow > 0) {
            fnc.current.warnmsg("最大行数は" + maxrow + "行です");
        }
    }

    function syncGridRowsFromApi(api) {
        let grid = isEmpty(api) ? gridApi : api;
        if (isEmpty(grid) || isEmpty(AGRef.current)) return [];
        const rows = AGRef.current.GetDatasource(grid);
        applyRowData(rows);
        return rows;
    }

    function addRowsWithLimit(rowcount, api, columnapi, warn = true) {
        if (rowcount <= 0 || isEmpty(AGRef.current)) return 0;
        let addrows = getAddableRowCount(rowcount, api);
        if (addrows <= 0) {
            if (warn) showMaxRowWarning();
            return 0;
        }
        AGRef.current.newRow(addrows, api, columnapi);
        syncGridRowsFromApi(api);
        if (warn && addrows < rowcount) {
            showMaxRowWarning();
        }
        return addrows;
    }

    function insertRowsWithLimit(rowindex, rowcount, api, columnapi, warn = true, callback = null) {
        if (rowcount <= 0 || isEmpty(AGRef.current)) {
            if (!isEmpty(callback)) callback(0, false);
            return 0;
        }
        let grid = isEmpty(api) ? gridApi : api;
        if (isEmpty(grid)) {
            if (!isEmpty(callback)) callback(0, false);
            return 0;
        }

        let overflowrows = getInsertOverflowRowCount(rowcount, grid);
        if (overflowrows > 0) {
            let maxrow = getMaxRowCount();
            fnc.current.confmsg(
                "最大行数は" + maxrow + "行です。行挿入を行いますか？",
                () => {
                    AGRef.current.insertRow(rowindex, rowcount, grid, columnapi);
                    removeLastDisplayedRows(overflowrows, grid);
                    syncGridRowsFromApi(grid);
                    if (!isEmpty(callback)) callback(rowcount, true);
                },
                () => {
                    if (!isEmpty(callback)) callback(0, false);
                }
            );
            return 0;
        }

        let addrows = getAddableRowCount(rowcount, grid);
        if (addrows <= 0) {
            if (warn) showMaxRowWarning();
            if (!isEmpty(callback)) callback(0, false);
            return 0;
        }
        AGRef.current.insertRow(rowindex, addrows, grid, columnapi);
        syncGridRowsFromApi(grid);
        if (!isEmpty(callback)) callback(addrows, true);
        return addrows;
    }

    function ensureInitRows(api, columnapi) {
        let initrow = getInitRowCount();
        if (initrow <= 0) return 0;
        let grid = isEmpty(api) ? gridApi : api;
        if (isEmpty(grid)) return 0;
        let addrows = initrow - grid.getDisplayedRowCount();
        if (addrows <= 0) return 0;
        return addRowsWithLimit(addrows, grid, columnapi, false);
    }

    function createColDef(all, columns) {
        var colDef = [
            colDefsInit,
            props.total ?
                {
                    field: 'grip', colId: 'grip', headerName: " ", lockPosition: true, suppressMenu: false,
                    width: 40, editable: false, filter: false, sortable: false, resizable: false, suppressColumnsToolPanel: true
                }
                :{
                    field: 'grip', colId: 'grip', headerName: " ", rowDrag: props.rowDrag!==false, lockPosition: true, suppressMenu: false,
                    width: 40, editable: false, filter: false, sortable: false, resizable: false, suppressColumnsToolPanel: true
                }
        ]
        if (isEnabled(props.masterDetail)) {
            let handle =
            {
                field: 'expand', colId: 'expand', headerName: " ", lockPosition: true, suppressMenu: false,hide:false,
                width: 40, editable: false, filter: false, sortable: false, resizable: false, suppressColumnsToolPanel: true,
                cellStyle: { 'padding-left': 0 }, menuTabs: ['generalMenuTab']
            }
            colDef.push(handle);
        }
        try {
            for (let i = 0; i < all.length; i++) {
                let hide = false;
                let result = columns.filter(e => e.columnid === all[i].columnid && e.type === all[i].type);
                hide = result.length === 0;
                let column = {
                    headerName: all[i].columnnm,
                    field: all[i].columnid,
                    colId: all[i].columnid,
                    hide: hide,
                    editable: function (params) {
                        if (params.context.entrylock) return false;

                        let edit = !all[i].locked;
                        if (!isEmpty(props.lockcell)) {
                            edit = props.lockcell(params, edit, formstatus, paneltype());
                        }
                        return edit;
                    },
                    datatype: all[i].datatype,
                    colinfo: all[i],
                    width:80,
                    useValueFormatterForExport: false,
                    menuTabs: ['generalMenuTab']
                }
                if (!isEmpty(props.ColdefSpecial)){
                    props.ColdefSpecial(column);
                }
                AGRef.current.SetColDefTypeInfo(all[i].datatype, column);
                colDef.push(column);
            }
        } catch (error) {
            console.log(error);
        }
        //前回のカラム状態適用
        if (initlayout.trim() !== '') {    //レイアウト指定
            //指定レイアウトの状態を復元
            colDef.forEach((item) => {
                var result = props.columns.find(e => e.columnid === item.colId);
                if (!isEmpty(result)) {
                    item.width = result.width;
                    item.hide = result.hidden !== '0';
                }
            });
        } else {            //保存済の列幅セット
            let newcolDef = AGRef.current.LoadColState(props.statusKey);
            if (isValidcolumndef(newcolDef)) {
                //列幅のみ適用
                for (let i = 0; i < colDef.length; i++) {
                    let item = newcolDef.find(e => e.colId === colDef[i].colId);
                    if (!isEmpty(item)) colDef[i].width = item.width;
                }
            }
        }
        return colDef;
    }
    function hdclass(params) {
        return themestyle.header.base;
    }
    const defaultcoldef = {
        filter: true,
        sortable: isEnabled(props.sortable),
        resizable: true,
        editable: true,
        menuTabs: listlock ? ['generalMenuTab']:['columnsMenuTab', 'generalMenuTab'],
        tooltipValueGetter: (params) => {
            if (params.column.colId.indexOf('tag') !== -1) return params.value;
            if (!isEmpty(props.columninfo)) {
                let col = props.columninfo.find(e => e.columnid === params.column.colId);
                if (isEmpty(col)) return null;
                if (col.primary) return null;
                if (col.datatype === CELLTYPE.TEXTAREA || col.datatype === CELLTYPE.TEXT) return params.value;
            }
            return null;
        },
        headerClass: function (params) {
            return hdclass(params);
        },
    };
    function onGridSizeChanged(param) {
        syncGridHeightState(param.api);
    }
    function onGridReady(param) {
        setGridApi(param.api);
        setGridColumnApi(param.columnApi);
        if (!isEmpty(props.onGridReady)) {
            props.onGridReady(param, props.id);
        }
    }
    function onFirstDataRendered(param) {
        let g_row = props.dataRef.current;
        if (!isEmpty(g_row)) {
            applyRowData(g_row);
        }
        syncGridHeightState(param.api);
        props.onFirstDataRendered(param, props.id);
    }
    //行入れ替え
    function RowDragEnd(param) {
        props.dataRef.current = AGRef.current.GetDatasource(gridApi);
        if (!isEmpty(props.SwapRow)) props.SwapRow(param);
    }
    //行削除
    function onRowDataChanged(param) {
        ensureInitRows(param.api, gridColumnApi);
        syncGridHeightState(param.api);
        props.dataRef.current = AGRef.current.GetDatasource(param.api);
        if (!isEmpty(props.RemoveRow)) props.RemoveRow(param);
    }
    function onModelUpdated(param) {
        syncGridHeightState(param.api);
    }
    //セルクリック
    function onCellClicked(param) {
        if (!isEmpty(props.CellClicked)) props.CellClicked(param);
    }
    //セルダブルクリック
    function onCellDoubleClicked (param) {
        if (!isEmpty(props.CellDoubleClicked)) props.CellDoubleClicked(param);
    }
    //列幅変更
    function ColumnResized(param) {
        if (param.finished) {
            ColumninfoAppy(param);
        }
    }
    //列表示変更
    function ColumnVisible(param) {
        if (!isEmpty(props.ColumnVisible)) props.ColumnVisible(param);
        ColumninfoAppy(param);
    }
    //列情報適用
    function ColumninfoAppy(param) {
        AGRef.current.SaveColState(props.statusKey);
        let cols = AGRef.current.GetApplyColumnDefs(columns);
        setcolumns(cols);
    }

    function valueParser(params) {
        let colinfo = params.colDef.colinfo;
        if (colinfo === null) return params.newValue;
        if (params.newValue === '') {
            if (!isEmpty(props.ValueChanged)) props.ValueChanged(params);
            return params.newValue;
        }

        if (colinfo.datatype === CELLTYPE.NUM) {
            if (!isFinite(params.newValue))
                return '';

            let num = Floor(Number(params.newValue), colinfo.decimalplace);
            if (colinfo.length !== 0 && colinfo.length < getInteferPointLength(num)) {
                //入力桁数が指定桁をオーバーしている場合
                num = getFirstDigits(num, colinfo.length)
            }
            return num;
        }
        if (colinfo.datatype === CELLTYPE.DATE) {
            try {
                if (!isDate(params.newValue)) return '';
                params.newValue = FormatDate(params.newValue);
            } catch {
                return '';
            }
        }
        if (colinfo.datatype === CELLTYPE.MASTER || colinfo.datatype === CELLTYPE.MASTERCODE || colinfo.primary) {
            if (isEmpty(params.newValue)) return '';
            //半角変換およびスペース削除
            params.newValue = trim(toHalfWidth(params.newValue));
            if (colinfo.length !== 0) {
                if (params.newValue.length > colinfo.length)
                    params.newValue = params.newValue.substring(0, colinfo.length);
                if (isNumber(params.newValue) && colinfo.format.indexOf('padzero') !== -1) {
                    //ゼロサプレス
                    params.newValue = PadZero(params.newValue, colinfo.length);
                }
            }
        }
        if (colinfo.datatype === CELLTYPE.SELECT || colinfo.datatype === CELLTYPE.SPIN) {
            let result = colinfo.options.find(e => e.code === params.newValue);
            if (isEmpty(result))
                return '';
        }
        if (colinfo.datatype === CELLTYPE.TAG) {
            return tagformat(params.newValue);
        }
        return params.newValue;
    }
    function valueFormatter(params) {
        try {
            if (isEmpty(params.value)) return '';
            let colinfo = params.colDef.colinfo;
            if (isEmpty(colinfo)) return params.value;
            if (colinfo.datatype === CELLTYPE.NUM) {
                var number = Number(params.value);
                return numformat(number, colinfo);
            }
            if (colinfo.datatype === CELLTYPE.MASTER) {
                if (params.value === params.data[params.colDef.colId + "_cd"])  //変更されていない
                    return params.value + ":" + params.data[params.colDef.colId + "_nm"];
                let keyinfo = "";
                if (colinfo.keyinfo !== "") {
                    keyinfo = colinfo.keyinfo.split("=")[0] + "=" + params.data[colinfo.keyinfo.split("=")[1]];
                }
                let data = fnc.current.getMaster(colinfo.dataid, params.value, keyinfo);
                if (data !== null) 
                    return params.value + ":" + data[colinfo.dbcolumn];

                return params.value;
            }
            if (colinfo.datatype === CELLTYPE.SELECT || colinfo.datatype === CELLTYPE.SPIN) {
                let result = colinfo.options.find(e => e.code === params.value.toString());
                if (!isEmpty(result))
                    return params.value + ":" + result.name;
                return params.value;
            }
        } catch {
            return params.value;
        }
        return params.value;
    }

    function PasteStart() {
        setcolumns(AGRef.current.GetApplyColumnDefs(columns));
    }

    function normalizeClipboardData(data) {
        if (isEmpty(data)) return [];
        let newdata = [...data];
        while (newdata.length > 1 && newdata[newdata.length - 1].every(value => value === '' || value === null || value === undefined)) {
            newdata.pop();
        }
        return newdata;
    }

    function processDataFromClipboard(params) {
        let data = normalizeClipboardData(params.data);
        if (data.length === 0) return data;

        PasteStart();

        if (props.AutoAddRow === false || props.total || isEmpty(AGRef.current)) {
            return data;
        }

        let focusedCell = params.api.getFocusedCell();
        if (isEmpty(focusedCell)) return data;

        let requiredRows = focusedCell.rowIndex + data.length;
        let displayedRows = params.api.getDisplayedRowCount();
        let addrows = requiredRows - displayedRows;
        if (addrows > 0) {
            addRowsWithLimit(addrows, params.api, gridColumnApi);
        }
        return data;
    }

    function setsearchitem(e, mode, allsku) {
        gridApi.stopEditing();
        try {
            let column = e.datainfo;
            if (column.datatype === CELLTYPE.TAG) {
                for (let i = 0; i < e.rowid.length; i++) {
                    let rowNode = gridApi.getRowNode(e.rowid[i]);
                    var tag = rowNode.data[e.key];
                    if (mode === 0) {   //追加
                        let newtag = tagformat(e.value + " " + tag);
                        if (tag.split(' ').length !== newtag.split(' ').length || tag === "")     //TAG追加あり
                            rowNode.setDataValue(e.key, newtag);
                    } else {            //削除
                        if (tag.length !== 0) {
                            let newtag = removetag(tag, e.value);
                            if (tag.split(' ').length !== newtag.split(' ').length || newtag.length === 0)     //TA削除あり
                                rowNode.setDataValue(e.key, newtag);
                        }
                    }
                }
            } else if (column.datatype === CELLTYPE.STICKY) {
                for (let i = 0; i < e.rowid.length; i++) {
                    let rowNode = gridApi.getRowNode(e.rowid[i]);
                    rowNode.setDataValue(e.key, { "mark": e.value, "color": e.color });
                }
            } else if (column.datatype === CELLTYPE.DATE) {
                for (let i = 0; i < e.rowid.length; i++) {
                    let rowNode = gridApi.getRowNode(e.rowid[i]);
                    rowNode.setDataValue(e.key, toStringDate(e.value));
                }
            } else {
                //MasterData呼出を集約するか判定 (トリガー項目がある場合一括取得)
                let coldefs = [];
                if (!isEmpty(column)) {
                    if (fnc.current.isSKU(column.dataid)) {
                        Suppress.current = true;
                        coldefs.push(e.colorinfo);
                        coldefs.push(e.sizeinfo);
                    } else {
                        if (AllSKU(column, allsku)) {   //全SKUの場合
                            //行の全データを取得（トリガ情報取得）
                            let colinfos = props.columninfo.filter(e => e.type === props.type);
                            coldefs.push(column);
                            let colcolumn = colinfos.find(e => fnc.current.isSKUColor(e.dataid));
                            coldefs.push(colcolumn);
                            let sizecolumn = colinfos.find(e => fnc.current.isSKUSize(e.dataid));
                            coldefs.push(sizecolumn);
                            fnc.current.getAllSKUdata(coldefs, colinfos, e.value, (data) => allskucallback(data, e));
                            fnc.current.searchlistclose();
                            return;
                        }
                        if (column.trigger.length !== 0) Suppress.current = true;
                        coldefs.push(column);
                    }
                }
                if (e.rowmode && e.items.length > 1) {
                   //複数選択
                    let currowNode = gridApi.getRowNode(e.currowid);   //呼出行
                    const applyRows = () => {
                        let rowNode = gridApi.getRowNode(e.currowid);   //呼出行
                        let rows = [];
                        AGRef.current.SetRowSelect(e.currowid);
                        for (let i = 0; i < e.items.length; i++) {
                            if (i !== 0) {
                                let rowid = rowNode.data.rowid;
                                rowNode = AGRef.current.NextrowNode(rowid);
                                if (rowNode === null) {     //次行なし
                                    addRowsWithLimit(e.items.length - i);  //足りない行追加
                                    rowNode = AGRef.current.NextrowNode(rowid);
                                    if (rowNode === null) break;
                                }
                                if (!isEmpty(column.keyinfo)) {  //d_prod_color etc..
                                    let keys = column.keyinfo.split(",");
                                    for (let j = 0; j < keys.length; j++) {
                                        let c = keys[j].split("=")[1];
                                        if (!isEmpty(c)) {   //関連キー情報セット ex)d_prod_code
                                            if (c.indexOf(":") === -1) {
                                                rowNode.setDataValue(c, currowNode.data[c]);
                                                setTriggerfielddata(c, currowNode.data, rowNode);   //Trigger項目セット
                                            } else {    //製品伝票c/#,サイズ
                                                let inst = c.split(':')[0];
                                                let prod = c.split(':')[1];
                                                rowNode.setDataValue(inst, currowNode.data[inst]);
                                                rowNode.setDataValue(prod, currowNode.data[prod]);
                                                setTriggerfielddata(inst, currowNode.data, rowNode);   //Trigger項目セット
                                                setTriggerfielddata(prod, currowNode.data, rowNode);   //Trigger項目セット
                                            }
                                        }
                                    }
                                }
                            }
                            if (fnc.current.isSKU(column.dataid)) {
                                //SKU
                                if(e.items[i].color !== null){
                                    let data = e.items[i].color;
                                    rowNode.setDataValue(e.colorkey, (e.colorinfo.datatype === CELLTYPE.MASTERREF ? data[e.colorinfo.dbcolumn] : data.code));
                                }
                                if(e.items[i].size !== null){
                                    let data = e.items[i].size;
                                    rowNode.setDataValue(e.sizekey, (e.sizeinfo.datatype === CELLTYPE.MASTERREF ? data[e.sizeinfo.dbcolumn] : data.code));
                                }
                            } else {
                                //Basic
                                let data = e.items[i].data;
                                rowNode.setDataValue(e.key, (column.datatype === CELLTYPE.MASTERREF ? data[e.datainfo.dbcolumn] : data.code));
                            }
                            let rowdata = rowNode.data;
                            if (!isEmpty(props.entrydataRef)) {
                                rowdata = { ...rowdata, ...props.entrydataRef.current };
                            }
                            rows.push(rowdata);
                        }
                        if (Suppress.current) {
                            //行の全データを取得
                            let colinfos = props.columninfo.filter(e => e.type === props.type);
                            fnc.current.getRowMasterdata(coldefs, colinfos, rows, (data) => rowcallback(data, rows, column.columnid));
                        }
                    };

                    if (mode === 0) {   //挿入
                        let next = AGRef.current.NextrowNode(currowNode.data.rowid);
                        if (next !== null) {
                            let rowcount = gridApi.getDisplayedRowCount();
                            insertRowsWithLimit(
                                next.rowIndex,
                                rowcount === 1 ? e.items.length : e.items.length - 1,
                                gridApi,
                                gridColumnApi,
                                true,
                                (count, success) => {
                                    if (success) applyRows();
                                }
                            );
                            fnc.current.searchlistclose();
                            return;
                        }
                    }
                    applyRows();
                } else {
                    let rows = [];
                    //単一選択
                    for (let i = 0; i < e.rowid.length; i++) {  //同一項目を選択行にセット
                        let rowNode = gridApi.getRowNode(e.rowid[i]);
                        if (fnc.current.isSKU(column.dataid)) {
                            //SKU
                            if (e.items[i].color !== null) {
                                let data = e.items[i].color;
                                rowNode.setDataValue(e.colorkey, (e.colorinfo.datatype === CELLTYPE.MASTERREF ? data[e.colorinfo.dbcolumn] : data.code));
                            }
                            if (e.items[i].size !== null) {
                                let data = e.items[i].size;
                                rowNode.setDataValue(e.sizekey, (e.sizeinfo.datatype === CELLTYPE.MASTERREF ? data[e.sizeinfo.dbcolumn] : data.code));
                            }
                        } else {
                            //Basic
                            rowNode.setDataValue(e.key, (column.datatype === CELLTYPE.MASTERREF ? e.items[0].data[e.datainfo.dbcolumn] : e.value));
                        }
                        let rowdata = rowNode.data;
                        if (!isEmpty(props.entrydataRef)) {
                            rowdata = { ...rowdata, ...props.entrydataRef.current };
                        }
                        rows.push(rowdata);
                    }
                    if (Suppress.current) {
                        //行の全データを取得（トリガ情報取得）
                        let colinfos = props.columninfo.filter(e => e.type === props.type);
                        if (!colinfos.some(e => e.columnid === column.columnid)) {
                            //追加定義の場合ターゲット情報追加
                            colinfos.push(coldefs[0]);
                        }
                       fnc.current.getRowMasterdata(coldefs, colinfos, rows, (data) => rowcallback(data, rows, column.columnid));
                    }
                }
            }
        } catch (e) { }
        fnc.current.searchlistclose();
    }
    //ソース行（d_prod_code）のトリガ項目を複写（関連項目を全コピー)
    function setTriggerfielddata(colid, data, rowNode) {
        if (!isEmpty(props.SetTriggerfield)) props.SetTriggerfield(colid,data,rowNode);
        let col = props.columninfo.find(e => e.columnid === colid);
        if (isEmpty(col.trigger)) return;
        for (let i = 0; i < col.trigger.length; i++) {
            try {
                if (!isEmpty(data)) {
                    rowNode.setDataValue(col.trigger[i].columnid, data[col.trigger[i].columnid]);
                    //rowNode.setDataValue(col.trigger[i].columnid, data[col.trigger[i].dbcolumn]); //SQL取得情報が取れない
                } 
            } catch { }
        }
    }
    function AllSKU(column, allsku) {
        if (column.dataid === "d_prod" || column.dataid === "d_inst" || column.dataid === "m_matl" || column.dataid === "m_smatl") {
            var params = DicVal(column, "searchparam");
            if (isEmpty(params)) return allsku;
            let ret = DicVal(params, "allsku");
            if (isEmpty(ret)) return allsku;
            if (ret.toLowerCase() === "false") return false;
            return allsku;
        } else {
            return false;
        }
    }
    function thisdatatype(colinfo) {
        if (isEmpty(colinfo)) return "";
        return colinfo.datatype;
    }
    function onCellValueChanged(params, id) {
        if (params.newValue === params.oldValue) return;

        let colinfo = params.colDef.colinfo;
        let datatype = thisdatatype(colinfo);

        fnc.current.modify();
        if (!isEmpty(props.modify)) props.modifyRef.current = true; //呼び元参照用

        if (params.newValue !== "") {
            let index = params.api.getDisplayedRowCount();
            if (index === params.rowIndex + 1) {
                if (props.AutoAddRow !== false && !props.total) {
                    //新規行追加
                    addRowsWithLimit(1, params.api, params.columnApi, false);
                }
            }
        }
        if (datatype === CELLTYPE.MASTER || datatype === CELLTYPE.MASTERREF ||
            datatype === CELLTYPE.MASTERCODE || datatype === CELLTYPE.MASTERASST) {
            //マスタ連携項目セット
            if (!Suppress.current) {    //検索リスト選択以外
                let rowNode = params.api.getRowNode(params.data.rowid);
                LinkFieldApply(colinfo, params.newValue, rowNode, params);
                if (!isEmpty(props.ValueChanged) && !Suppress.current) props.ValueChanged(params);
                return;
            }
        }
        if (datatype === CELLTYPE.NUM) {
            //計算処理
            let formulalist = props.columninfo.filter(e => e.type === props.type && !isEmpty(e.formula));
            if (formulalist.length !== 0) {
                let rowNode = params.api.getRowNode(params.data.rowid);
                for (let i = 0; i < formulalist.length; i++) {
                    let cell = formulalist[i];
                    if (cell.formula.indexOf("[" + colinfo.columnid + "]") !== -1) {
                        let formula = replaceall(cell.formula, "[" + colinfo.columnid + "]", isNaN(params.newValue) ? 0 : params.newValue);
                        let fields = formula.match(/\[.*?\]/g);
                        if (fields.length !== 0) {
                            for (let j = 0; j < fields.length; j++) {
                                let f = fields[j].replace("[", "").replace("]", "");
                                let value = NumConv(rowNode.data[f]);
                                formula = formula.replace(fields[j], value);
                            }
                        }
                        try {
                            let result = eval(formula);
                            //小数桁丸め
                            result = GetDesitRound(result, cell.rounding, cell.decimalplace);
                            rowNode.setDataValue(cell.columnid, result);
                        } catch {
                            rowNode.setDataValue(cell.columnid, null);
                            console.log(formula);
                        }
                    }
                }
            }
        }

        if (!isEmpty(props.ValueChanged) && !Suppress.current) props.ValueChanged(params);
    }
    function cellEditorSelector(params) {
        let colinfo = AGRef.current.GetColumnInfo(params.colDef.colId, props.columninfo);
        if (isEmpty(colinfo)) return { component: "agTextCellEditor" };
        if (colinfo.datatype === CELLTYPE.TEXTAREA) {
            return {
                component: "agLargeTextCellEditor",
                params: { maxLength: 5000 }
            };
        }
        return { component: "agTextCellEditor" };
    }
    function allskucallback(data, e){
        console.log("*** allskucallback ***");
        if (isEmpty(AGRef.current)) return;
        let currowNode = gridApi.getRowNode(e.currowid);   //呼出行
        const applyRows = () => {
            AGRef.current.SetRowSelect(e.currowid);
            let rowNode = gridApi.getRowNode(e.currowid);   //呼出行
            var rows = [];
            for (let i = 0; i < data.length ; i++) {
                if (i !== 0) {
                    let rowid = rowNode.data.rowid;
                    rowNode = AGRef.current.NextrowNode(rowid);
                    if (rowNode === null) {     //次行なし
                        addRowsWithLimit(data.length);  //足りない行追加
                        rowNode = AGRef.current.NextrowNode(rowid);
                        if (rowNode === null) break;
                    }
                }
                let newdata = { ...rowNode.data, ...data[i] };
                if (!isEmpty(props.entrydataRef)) {
                    newdata = { ...newdata, ...props.entrydataRef.current };
                }
                rowNode.setData(newdata);
                //セル内名称表示
                var params = {
                    suppressFlash: true,
                    rowNodes: [rowNode],
                };
                gridApi.refreshCells(params);
                rows.push(newdata);
            }
            props.dataRef.current = AGRef.current.GetDatasource(gridApi);
            if (!isEmpty(props.RowValueChanged)) props.RowValueChanged("", rows);
            fnc.current.modify();
            if (!isEmpty(props.modify)) props.modifyRef.current = true; //呼び元参照用
            fnc.current.wait(false);
        };

        let next = AGRef.current.NextrowNode(currowNode.data.rowid);
        if (next !== null) {
            let rowcount = gridApi.getDisplayedRowCount();
            insertRowsWithLimit(
                next.rowIndex,
                rowcount === 1 ? data.length : data.length - 1,
                gridApi,
                gridColumnApi,
                true,
                (count, success) => {
                    if (success) applyRows();
                }
            );
            return;
        }
        applyRows();
    }
    function rowcallback(data, targets,colid) {
        console.log("*** rowcallback ***");
        if (isEmpty(AGRef.current)) return;
        let src = AGRef.current.GetDatasource(gridApi);
        for (let r = 0; r < data.length; r++) {
            let row = src.find(e => e.rowid === data[r].rowid);
            if (isEmpty(row)) continue;
            for (let key in data[r]) {
                if (key === "callRecords") continue;    //MasterDetailを除く
                row[key] = data[r][key];
            }
        }
        var rows = [];
        props.dataRef.current = src;
        for (let i = 0; i < targets.length; i++) {
            let rowNode = gridApi.getRowNode(targets[i].rowid);
            if (isEmpty(rowNode)) continue;
            let newData = src.find(e => e.rowid === targets[i].rowid);
            rowNode.setData(newData);
            rows.push(newData);
        }
        if (!isEmpty(props.RowValueChanged)) props.RowValueChanged(colid, rows);
        fnc.current.wait(false);
        Suppress.current = false;
    }
    function LinkFieldApply(colinfo, value, rowNode, params) {
        //参照カラムを取得
        let others = colinfo.trigger;
        if (colinfo.datatype === CELLTYPE.MASTER) {
            others = [...colinfo.trigger, ...[{ columnid: colinfo.columnid, dbcolumn: colinfo.dbcolumn }]];
        }
        let dataid = colinfo.dataid;
        let keyinfo = "";
        if (colinfo.keyinfo !== "" && colinfo.datatype !== CELLTYPE.SELECT && colinfo.datatype !== CELLTYPE.SPIN) {
            if (colinfo.dataid.indexOf("d_slip") !== -1) {
                var key = colinfo.keyinfo.split("=")[1];
                dataid = colinfo.dataid.replace("d_slip", "d_prod");
                keyinfo = dataid + "_key=" + rowNode.data[key.split(":")[1]];
            } else {
                keyinfo = colinfo.keyinfo.split("=")[0] + "=" + rowNode.data[colinfo.keyinfo.split("=")[1]];
            }
        }
        if (!fnc.current.existMaster(dataid, value, keyinfo) && !isEmpty(value)) {
            if (colinfo.datatype !== CELLTYPE.MASTERREF) {
                //サーバーより情報を取得
                let rowdata = rowNode.data;
                if (!isEmpty(props.entrydataRef)) {
                    rowdata = { ...rowdata, ...props.entrydataRef.current };
                }
                let sku = props.columninfo.filter(e => fnc.current.isSKU(e.dataid));
                if (sku.length !== 0 && (colinfo.dataid === "d_prod" || colinfo.dataid === "d_inst" || colinfo.dataid === "m_matl" || colinfo.dataid === "m_smatl"
                    || colinfo.dataid === "d_porder_row")) {
                    //行の全データを取得
                    let colinfos = props.columninfo.filter(e => e.type === props.type);
                    fnc.current.getRowMasterdata([colinfo], colinfos, [rowdata], (data) => rowcallback(data, [rowNode.data], colinfo.columnid));
                } else {
                    fnc.current.getMasterdata(dataid, value, keyinfo, others, rowdata, (data) => callback(data, colinfo, rowNode));
                }
                if (!isEmpty(props.ValueChanged) && !Suppress.current) props.ValueChanged(params);
            }
       } else {
            if (colinfo.datatype === CELLTYPE.MASTERREF) {
                //名称置き換え
                let data = fnc.current.getMaster(colinfo.dataid, value, keyinfo);
                rowNode.setDataValue(colinfo.columnid, DicVal(data,colinfo.dbcolumn));
                if (others.length === 0) {
                    if (!isEmpty(props.ValueChanged) && !Suppress.current) props.ValueChanged(params);
                }
            }
            if (others.length !== 0) {  //関連セットするデータあり
                if (isEmpty(value)) {
                    //入力値なし Readonlyフィールドクリア
                    setLinkfielddata(colinfo, null, rowNode);
                    if (!isEmpty(props.ValueChanged) && !Suppress.current) props.ValueChanged(params);
                    return
                }
                let data = fnc.current.getMaster(dataid, value,keyinfo);
                //すべての項目が揃っているかチェック
                let exist = true;
                for (let i = 0; i < others.length; i++) {
                    let key = others[i].dbcolumn;
                    if (data[key] === undefined) {
                        exist = false; break;
                    }
                }
                if (exist) {
                    setLinkfielddata(colinfo, data, rowNode);
                    if (!isEmpty(props.ValueChanged) && !Suppress.current) props.ValueChanged(params);
                } else {
                    let rowdata = rowNode.data;
                    if (!isEmpty(props.entrydataRef)) {
                        rowdata = { ...rowdata, ...props.entrydataRef.current };
                    }
                    let sku = props.columninfo.filter(e => fnc.current.isSKU(e.dataid));
                    if (sku.length !== 0 && (colinfo.dataid === "d_prod" || colinfo.dataid === "d_inst" || colinfo.dataid === "m_matl" || colinfo.dataid === "m_smatl"
                                          || colinfo.dataid === "d_porder_row")) {
                        //行の全データを取得
                        let colinfos = props.columninfo.filter(e => e.type === props.type);
                        fnc.current.getRowMasterdata([colinfo], colinfos, [rowdata], (data) => rowcallback(data, [rowNode.data], colinfo.columnid));
                    } else {
                        //サーバーより情報を取得
                        fnc.current.getMasterdata(dataid, value, keyinfo, others, rowdata, (data) => callback(data, colinfo, rowNode));
                    }
                }
            }
        }
        function callback(data, colinfo, rowNode) {
            if (!isEmpty(data) && fnc.current !== null) {
                fnc.current.setMaster(data);
            }
            if (rowNode !== undefined) {
                if (colinfo.datatype === CELLTYPE.MASTER) {
                    //セル内名称表示
                    var params = {
                        suppressFlash: true,
                        rowNodes: [rowNode],
                    };
                    gridApi.refreshCells(params);
                }
                if (!isEmpty(data)) {
                    if (colinfo.datatype === CELLTYPE.MASTERREF) {
                        //名称置き換え
                        rowNode.setDataValue(colinfo.columnid, data[colinfo.dbcolumn]);
                    }
                }
                setLinkfielddata(colinfo, data, rowNode);
            }
            fnc.current.wait(false);
        }
    }
    function setLinkfielddata(col, data, rowNode) {
        if (isEmpty(col.trigger)) return;
        for (let i = 0; i < col.trigger.length; i++) {
            try {
                if (!isEmpty(data)) {
                    if (col.trigger[i].dbcolumn.indexOf("dbo") !== -1) {
                        //function
                        rowNode.setDataValue(col.trigger[i].columnid, data["fnc_" + col.trigger[i].columnid]);
                    } else {
                        rowNode.setDataValue(col.trigger[i].columnid, data[col.trigger[i].dbcolumn]);
                    }
                } else {
                    //クリアする指定
                    if (col.trigger[i].triggerclear) {
                        rowNode.setDataValue(col.trigger[i].columnid, "");
                    } else {
                        //マスタにない場合でロックセルの場合クリア
                        let coldef = props.columninfo.find(e => e.columnid === col.trigger[i].columnid);
                        if (!isEmpty(coldef)) {
                            if (coldef.locked) {
                                rowNode.setDataValue(col.trigger[i].columnid, "");
                            }
                        }
                    }
                }
            } catch { }
        }
    }

    function getMainMenuItems(params) {
        var athleteMenuItems = [];
        athleteMenuItems.push({
            name: '列固定（Pin）',
            icon: copyicon(2),
            subMenu: [
                {
                    name: '先頭',
                    checked: params.column.pinned==='left',
                    action: function () {
                        params.api.setColumnsPinned([params.column.colId], 'left');
                    },
                },
                {
                    name: '末尾',
                    checked: params.column.pinned === 'right',
                    action: function () {
                        params.api.setColumnsPinned([params.column.colId], 'right');
                    },
                },
                {
                    name: 'No Pin',
                    tooltop:'固定されていない列',
                    checked: isEmpty(params.column.pinned),
                    action: function () {
                        params.api.setColumnsPinned([params.column.colId], 'none');
                    },
                },
            ]
        });
        athleteMenuItems.push('separator');
        athleteMenuItems.push({
            name: '列幅最適化-すべての列',
            action: () => {
                var allColumnIds = [];
                params.api.getAllGridColumns().forEach(function (column) {
                    if (column.colId !== 'grip')
                        allColumnIds.push(column.colId);
                });
                params.api.autoSizeColumns(allColumnIds, false);
            },
        });
        athleteMenuItems.push({
            name: '列幅最適化-指定列',
            action: () => {
                params.api.autoSizeColumns([params.column.colId], false);
            },
        });
        if (params.column.colId.indexOf("ag-Grid-AutoColumn") !== -1) {
            athleteMenuItems.push(
                'separator',
                {
                    name: 'Expand(全開)',
                    action: () => {
                        params.api.expandAll();
                    },
                },
                {
                    name: 'Collapse(全閉)',
                    action: () => {
                        params.api.collapseAll();
                    },
                },
            //    'separator',
            //    {
            //        name: 'Group解除',
            //        action: () => {
            //            params.api.setRowGroupColumns([]);
            //        },
            //    }
            );
        }
        if (params.column.colId === "expand") {
            athleteMenuItems.push(
                'separator',
                {
                    name: 'Expand(全開)',
                    action: () => {
                        setTimeout(function () {
                            params.api.forEachNode(function (node) {
                                node.setExpanded(true);
                            });
                        }, 0);
                    },
                },
                {
                    name: 'Collapse(全閉)',
                    action: () => {
                        setTimeout(function () {
                            params.api.forEachNode(function (node) {
                                node.setExpanded(false);
                            });
                        }, 0);
                    },
                },
            );
        }
        return athleteMenuItems;
    };
     const autoGroupColumnDef = {
         menuTabs: ['generalMenuTab'],
         editable:false,
         cellRendererParams: {
            suppressCount: true,
        }
    };
   function copyicon(type) {
        switch (type) {
            case 0:
                return (
                    '<i class="material-icons min">content_copy</i>'
                );
            case 1:
                return (
                    '<i class="material-icons min">copy_all</i>'
                    );
            case 2:
                    return (
                        '<i class="material-icons min">push_pin</i>'
                );
            default:
                return null;
        }
    }
    function getContextMenuItems(params) {
        if (props.total) return null;
        if (props.rowContext === false) return null;
        let master = false;
        let dataidctrl = "";
        if (!isEmpty(props.columninfo) && !isEmpty(params.column)) {
            let coldefs = props.columninfo.find(e => e.columnid === params.column.colId && e.type === props.type);
            if (!isEmpty(coldefs)) {
                if (coldefs.datatype === CELLTYPE.MASTERREF || coldefs.datatype === CELLTYPE.MASTER || coldefs.datatype === CELLTYPE.MASTERCODE || coldefs.datatype === CELLTYPE.MASTERASST) {
                    master = true; dataidctrl = coldefs.dataidctrl;
                }
            }
        }
        var result = ['cut','paste','copy','copyWithHeaders'];
        result.push({
            name: '選択行のコピー',
            icon: copyicon(1),
            action: function () {
                params.api.copySelectedRowsToClipboard(false, false);
            },
        });

        if (props.rowContext !== 1) {
            result.push(
                'separator',
                {
                    name: '行挿入',
                    tooltip: '選択位置に選択行数分新規行を挿入します',
                    action: function () {
                        var selectedRows = params.api.getSelectedNodes();
                        if (!selectedRows || selectedRows.length === 0) {
                            fnc.current.warnmsg("行を選択してください");
                            return;
                        }
                        if (!isEmpty(props.QueryInsertRow)) {
                            if (!props.QueryInsertRow(selectedRows[0])) return;
                        }
                        let addindex = selectedRows[0].rowIndex;
                        insertRowsWithLimit(addindex, selectedRows.length, params.api, params.columnApi);
                    },
                },
                {
                    name: '行追加',
                    tooltip: 'シート末尾に行を追加します',
                    subMenu: [
                        {
                            name: '１行',
                            action: function () { addRowsWithLimit(1, params.api, params.columnApi); },
                        },
                        {
                            name: '10行',
                            action: function () { addRowsWithLimit(10, params.api, params.columnApi); },
                        },
                        {
                            name: '50行',
                            action: function () { addRowsWithLimit(50, params.api, params.columnApi); },
                        },
                    ]
                },
                {
                    name: '行削除',
                    tooltip: 'シートから選択行を削除します。※データは削除されません',
                    action: function () {
                        const selectedRows = params.api.getSelectedRows();
                        if (!selectedRows || selectedRows.length === 0) {
                            fnc.current.warnmsg("行を選択してください");
                            return;
                        }
                        if (!isEmpty(props.QueryRemoveRow)) {
                            if (!props.QueryRemoveRow(selectedRows)) return;
                        }
                        params.api.applyTransaction({ remove: selectedRows });
                    },
                },
                //'separator',
                //{
                //    name: 'マスタコード変換',
                //    tooltip: 'シート内容からマスタコードを取得しセットします',
                //    action: function () {
                //        fnc.current.clearconvdescription();
                //        const ranges = params.api.getCellRanges();
                //        if (ranges.length === 0) {
                //            fnc.current.warnmsg("変換対象セルを選択してください");
                //            return;
                //        }
                //        let columns = [];
                //        for (let i = 0; i < ranges[0].columns.length; i++) {
                //            let column = AGRef.current.GetColumnInfo(ranges[0].columns[i].colId, props.columninfo);
                //            if (column.datatype === CELLTYPE.MASTER || column.datatype === CELLTYPE.MASTERCODE || column.datatype === CELLTYPE.MASTERASST) {
                //                columns.push(column);
                //            }
                //        }
                //        if (columns.length === 0) {
                //            fnc.current.warnmsg("変換対象項目が含まれていません。マスタ項目を選択してください");
                //            return;
                //        }
                //        let rows = AGRef.current.GetRangeSelectrowdata(ranges);
                //        fnc.current.postaxios('common/MasterConvert', { rowdata: rows, columns: columns },
                //            {
                //                onSuccess: function (data) {
                //                    if (data.warning.length === 0) {
                //                        fnc.current.warnmsg("変換可能なデータは存在しません");
                //                    }
                //                    else {
                //                        if (data.master.length !== 0) {
                //                            for (let i = 0; i < data.master.length; i++) {
                //                                fnc.current.setMaster(data.master[i]);
                //                            }
                //                        }
                //                        //変換できた行データを反映
                //                        data.warning.forEach(function (values) {
                //                            let node = params.api.getRowNode(values.rowid);
                //                            node.setDataValue(values.col, values.value);
                //                        });
                //                        fnc.current.showconvdescription(data.warning);
                //                        params.api.redrawRows();   //Re Render
                //                        fnc.current.success();
                //                    }
                //                    fnc.current.wait();
                //                },
                //                errmsg: "マスタコード変換に失敗しました"
                //            }
                //        )
                //    },
            //    }
            );
        }
        if (!isEmpty(DicVal(props.panel, "ptntype", ""))) {
            result.push(
                'separator',
                {
                    name: 'パターン呼出/削除',
                    tooltip: '登録済のパターンリストを表示し呼び出し及びパターン削除を行います',
                    action: function () {
                        //検索リストOPEN
                        const datainfo = { datatype: CELLTYPE.MASTER, dataid: "sm_ptn", primary: false, type: props.panel.ptntype }
                        fnc.current.searchlistopen({
                            label: "パターン - " + props.panel.name,
                            multiple: false,
                            rowmode: false,
                            data: datainfo,
                            doApply: SetPattern,
                        });
                        function SetPattern(e) {
                            fnc.current.searchlistclose();
                            fnc.current.postaxios('common/GetPattern', { code: e.value, type: props.panel.ptntype, note: props.panel.ptnparam, request: e.shared?"shared":null },
                                {
                                    onSuccess: function (data) {
                                        applyRowData(data.rowdata);
                                        fnc.current.wait();
                                    },
                                    errmsg: "パターン取得に失敗しました"
                                }
                            );
                        }
                        return;
                    },
                },
                {
                    name: 'パターン登録',
                    tooltip: '表示中の内容をパターン登録します',
                    action: function () {
                        let data = AGRef.current.GetDatasource(gridApi);
                        if (data.length === 0) {
                            fnc.current.warnmsg("登録するデータが存在しません");
                            return;
                        }
                        if (!isEmpty(props.panel.ptnparam)) {
                            let isExist = false;
                            let fds = props.panel.ptnparam.split(',');
                            for (let i = 0; i < data.length; i++) {
                                for (let j = 0; j < fds.length; j++) {
                                    if (!isEmpty(DicVal(data[i], fds[j].split('=')[1]))) {
                                        isExist = true; break;
                                    }
                                }
                                if (isExist) break;
                            }
                            if (!isExist) {
                                fnc.current.warnmsg("登録するデータが存在しません");
                                return;
                            }
                        }
                        fnc.current.formdialogopen({
                            title: "パターン登録 - " + props.panel.name , inputname: "パターン名", dialogtype: 0,
                            placeholder: "パターン名を入力してください",
                            contents: "表示中の内容を指定したパターン名で登録します",
                            customcontents: admin === "1" ? 2 : null,
                            checkboxlabel:"共有する（すべてのログインユーザーに公開されます）",
                            onApply: (value) => exec(value,false)
                        });
                        function exec(value, update) {
                            fnc.current.postaxios('common/PatternSave', { rowdata: data, key: value['name'], share: value['check']?"1":"0", update: update, tabletype: props.panel.ptntype, initlayout: props.panel.ptnparam, coldef: AGRef.current.GetshownColDef() },
                                {
                                    onSuccess: function (data) {
                                        fnc.current.wait();
                                        if (data.errDescription.length !== 0) {
                                            fnc.current.confmsg("このパターン名は登録済です。上書してよろしいですか？", () => exec(value, true));
                                        }
                                        else {
                                            fnc.current.success();
                                            fnc.current.formdialogclose();
                                        }
                                    },
                                    errmsg: "パターン登録に失敗しました"
                                }
                            );
                        }
                   },
                }
            );
        }
        if (master && !isEmpty(dataidctrl)) {
            result.push(
                'separator',
                {
                    name: '参照マスタ起動',
                    tooltip: '参照先マスタ画面を別タブで起動します',
                    action: function () {
                        let menu = menudata.menus.find(e => e.controller === dataidctrl);
                        if (isEmpty(menu)) return;
                        let state = undefined;
                        if (!isEmpty(params.value)) {
                            state = { status: "ENTRY", code: params.value };
                        }
                        let key = continueSession(user, menudata, menu, state);
                        let newurl = menu.controller;
                        if (newurl.indexOf('?') === -1) {
                            newurl += "?key=" + key;
                        } else {
                            newurl += "&key=" + key;
                        }
                        window.open('/' + newurl);
                        return;
                    },
                }
            );
        }
        return result;
    };

    const columnDefs = useMemo(
        () =>
            (Array.isArray(columns) ? columns : [colDefsInit]).map((column) => ({
                ...column,
                cellRenderer: ListEditRenderer,
                cellRendererParams: {
                    columninfo: props.columninfo,
                    suppressMouseEventHandling: function (params) {
                        const target = params.event?.target;
                        const isEditButton = !!target?.closest?.('[data-list-edit-trigger="true"]');
                        const isSelectedRow = !!params.node?.isSelected?.();

                        return isEditButton && isSelectedRow;
                    },
                    clicked: function (e) {
                        // 検索リストOPEN
                        let id = e.colDef.colId;
                        let result = e.colDef.colinfo;
                        if (result === undefined) return;

                        let tag: any[] = [];
                        if (result.datatype === CELLTYPE.TAG && e.colDef.editable) {
                            tag = AGRef.current.GetTagDataList(id);
                        }

                        if (
                            result.datatype === CELLTYPE.MASTER ||
                            result.datatype === CELLTYPE.TAG ||
                            result.datatype === CELLTYPE.MASTERREF ||
                            result.datatype === CELLTYPE.MASTERCODE ||
                            result.datatype === CELLTYPE.MASTERASST
                        ) {
                            if (isEmpty(result.dataid)) {
                                fnc.current.warnmsg(
                                    'システム設定を確認してください。dataidが設定されていません'
                                );
                                return;
                            }
                        }

                        let currowid = e.data.rowid;
                        let rowid = [e.data.rowid];
                        let rows = gridApi.getSelectedRows();
                        let res = rows.filter((r) => r.rowid === currowid);
                        if (res.length !== 0 && isEmpty(result.keyinfo)) {
                            // 選択行に呼出行が存在する場合選択行すべてを対象
                            rowid = rows.map((p) => p.rowid);
                        }

                        let rowdata = DeepCopy(e.data);
                        if (!isEmpty(props.entrydataRef)) {
                            rowdata = {
                                ...rowdata,
                                ...DeepCopy(props.entrydataRef.current),
                            }; // ヘッダ情報付加
                        }

                        setcolumns(AGRef.current.GetApplyColumnDefs(columns)); // 列状態を更新

                        fnc.current.searchlistopen({
                            label: e.colDef.headerName,
                            multiple:
                                result.multiple ||
                                result.datatype === CELLTYPE.TAG ||
                                result.primary,
                            rowmode: result.multiple || result.primary,
                            data: result,
                            rowid: rowid,
                            currowid: currowid,
                            taglist: tag,
                            doApply: setsearchitem,
                            exdataid: props.prymaryid,
                            rowdata: rowdata,
                            gridApi: gridApi,
                            columninfo: props.columninfo,
                        });
                    },
                },
                valueParser,
                valueFormatter,
                cellEditorSelector,
            })),
        [columns, props.columninfo, props.entrydataRef, props.prymaryid, gridApi]
    );

    const cellSelection = useMemo(() => {
        return {
            enableColumnSelection: true,
            handle: {
                mode: 'fill',
            },
       };
    }, []);
    const gridClassName = displayedRowCount === 0 ? "ag-theme-balham entry-grid-empty" : "ag-theme-balham";
    return (
        <div id={props.elemid} className={gridClassName} style={getGridStyle()}>
            <AgGridReact
                theme={themeBalham}
                columnMenu="legacy"
                getRowId={params => params.data.rowid}
                rowNumbers={{
                    headerStyle: {
                        backgroundColor: "#f0f0f0",
                        color: "#3d4765"
                    }
                }}
                cellSelection={cellSelection}
                enableBrowserTooltips={true}
                tooltipShowDelay={0}
                headerHeight={30}
                defaultColDef={defaultcoldef}
                enableRangeSelection={true}
                detailRowHeight={200}
                masterDetail={isEnabled(props.masterDetail)}
                detailCellRendererParams={detailCellRendererParams}
                autoGroupColumnDef={autoGroupColumnDef}
                groupDisplayType={'multipleColumns'}
                suppressMultiRangeSelection={true}
                suppressDragLeaveHidesColumns={listlock}
                suppressMovableColumns={listlock}
                enableFillHandle={true}
                fillHandleDirection={isEmpty(props.fillHandleDirection) ? 'y' : props.fillHandleDirection}
                getMainMenuItems={getMainMenuItems}
                getContextMenuItems={getContextMenuItems}
                rowDragManaged={props.rowDragManaged === false ? false : true}
                popupParent={document.querySelector('body')}
                domLayout={'autoHeight'}
                modules={[AllCommunityModule, AllEnterpriseModule]}
                getRowNodeId={RowNodeId}
                getRowStyle={props.getRowStyle}
                rowSelection={props.total ? 'single' : 'multiple'}
                rowDeselection={props.total}
                onGridReady={onGridReady}
                onFirstDataRendered={onFirstDataRendered}
                processDataFromClipboard={processDataFromClipboard}
                onCellValueChanged={onCellValueChanged}
                onColumnVisible={ColumnVisible}
                onColumnPinned={ColumninfoAppy}
                onColumnMoved={ColumninfoAppy}
                onColumnResized={ColumnResized}
                onCellClicked={onCellClicked}
                onCellDoubleClicked={onCellDoubleClicked}
                onRowDragEnd={RowDragEnd}
                onVirtualRowRemoved={onRowDataChanged}
                rowData={rowData}
                context={gridcontext}
                suppressRowHoverHighlight={props.total}
                suppressRowClickSelection={props.total}
                onGridSizeChanged={onGridSizeChanged}
                onModelUpdated={onModelUpdated}
                columnDefs={columnDefs}
                localeText={{
                    cut: '切り取り',
                    paste: '貼り付け',
                    copy: 'コピー',
                    copyWithHeaders: 'ヘッダ付きコピー',
                }}
            >
            </AgGridReact>
            <AGFunc
                ref={AGRef}
                gridApi={gridApi}
                gridColumnApi={gridColumnApi}
                gridid={props.id}
            />
        </div>
    );

}
